module.exports = __webpack_public_path__ + "assets/img/gel_icon.673cfd81.svg";